import React, { useState } from 'react';
import * as S from './TransactionsList.styles';
import { Transaction } from '@/mock-data/transactions';
import { TransactionsItem } from '@/components/Profile/Transactions/TransactionsItem';
import { TransactionsDrawer } from '@/components/Profile/Transactions/TransactionsDrawer';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { sleep } from '@/utils/helpers';
import { MODAL_ANIMATION_DURATION } from '@/styles/constants';

interface TransactionsEmptyProps {
  transactions: Transaction[];
}

export const TransactionsList: React.FC<TransactionsEmptyProps> = ({
  transactions,
}) => {
  const [selectedTx, setSelectedTx] = useState<null | Transaction>(null);
  const [isOpen, toggle] = useToggleOpenState();

  async function showTxDetails(tx: Transaction) {
    setSelectedTx(tx);
    await sleep(0);
    toggle(true);
  }

  async function close() {
    toggle(false);
    await sleep(MODAL_ANIMATION_DURATION);
    setSelectedTx(null);
  }

  return (
    <>
      <S.Box>
        {transactions.map(transaction => (
          <TransactionsItem
            key={transaction.id}
            transaction={transaction}
            showTxDetails={showTxDetails}
          />
        ))}
      </S.Box>

      <TransactionsDrawer
        isOpen={isOpen}
        close={close}
        transaction={selectedTx}
      />
    </>
  );
};
